export default function getSeo(seo) {
  const title = `${seo.title} - Annotate.tv`
  const description =
    seo.description ||
    'Annotate.tv is a video annotation tool for YouTube. Take timestamped notes, chat with videos using AI, extract text from slides, and export to Notion, Evernote, and Readwise.'
  const canonical = seo.canonical
    ? `https://annotate.tv${seo.canonical}`
    : 'https://annotate.tv/'

  const defaultSeo = {
    description,
    openGraph: {
      url: canonical,
      title,
      description,
      type: 'website',
      images: [
        {
          url: 'https://annotate.tv/img/og-image.png',
          width: 1200,
          height: 627,
          alt: 'Annotate.tv',
        },
      ],
      site_name: 'Annotate.tv',
    },
    twitter: {
      handle: '@TucciMatias',
      site: '@Annotate_TV',
      cardType: 'summary_large_image',
    },
  }

  const actualSeo = {
    ...defaultSeo,
    ...seo,
    title,
    description,
    canonical,
  }

  return actualSeo
}

// Baseline SEO applied to every route via <DefaultSeo> in _app.
// Per-page <NextSeo> overrides these. No canonical here on purpose —
// canonical must be page-specific.
export function getDefaultSeo() {
  const title = 'Annotate.tv - Take notes on videos'
  const description =
    'Take timestamped notes on YouTube videos, chat with any video using AI, extract text from slides, and export your notes to PDF, Notion, Obsidian, and Readwise.'

  return {
    title,
    description,
    openGraph: {
      url: 'https://annotate.tv/',
      title,
      description,
      type: 'website',
      images: [
        {
          url: 'https://annotate.tv/img/og-image.png',
          width: 1200,
          height: 627,
          alt: 'Annotate.tv',
        },
      ],
      site_name: 'Annotate.tv',
    },
    twitter: {
      handle: '@TucciMatias',
      site: '@Annotate_TV',
      cardType: 'summary_large_image',
    },
  }
}

function getSeoDescription(description) {
  const maxSeoDescription = 160
  const ellipsis = '...'

  if (description.length > maxSeoDescription) {
    const shorter = description.slice(0, maxSeoDescription - ellipsis.length)
    return `${shorter}${ellipsis}`
  } else {
    return description
  }
}

export function getVideoSeo({ video, isReadOnly }) {
  const url = `/${isReadOnly ? 'watch' : 'video'}/${video.slug ?? video._id}`
  const title = video.title
  const description = getSeoDescription(video.description)
  const ogImage = video.thumbnails.maxres
    ? video.thumbnails.maxres.url
    : video.thumbnails.default.url

  const videoSeo = {
    title,
    description: description,
    canonical: url,
    openGraph: {
      url: `https://annotate.tv${url}`,
      title: `${title} - Annotate.tv`,
      description: description,
      type: 'website',
      images: [
        {
          url: ogImage,
          alt: title,
          width: 1280,
          height: 720,
        },
      ],
      site_name: 'Annotate.tv',
    },
  }

  return getSeo(videoSeo)
}
